import Vue from "vue";
import VueI18n from "vue-i18n";
import App from "./App";
import router from "./router";
import cognito from "./cognito";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "@/assets/css/main.css";
import vmodal from "vue-js-modal";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(vmodal);

Vue.config.productionTip = false;

let GlobalData = new Vue({
  data: {
    $token: "No comment."
  }
});

Vue.mixin({
  methods: {
    $_token() {
      return GlobalData.$data.$token;
    },
    $_setToken(newMsg) {
      GlobalData.$data.$token = newMsg;
    }
  },
  computed: {
    $token: {
      get: function() {
        return GlobalData.$data.$token;
      },
      set: function(newMsg) {
        GlobalData.$data.$token = newMsg;
      }
    }
  }
});

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: navigator.language.split("-")[0],
  fallbackLocale: "ja", // 追加
  messages: {
    ja: require("../lang/ja.json"),
    en: require("../lang/en.json")
  }
});

/* eslint-disable no-new */
new Vue({
  el: "#app",
  i18n: i18n,
  router,
  cognito,
  template: "<App/>",
  components: { App },
  showModal: false
});



// WEBPACK FOOTER //
// ./src/main.js